import size from "../sizes";

export default [
  {
    id: `description`,
    title: `О товаре`,
  },
  {
    id: `material`,
    title: `Описание`,
    content: {
      description: `
        <p>Пожалуй, невозможно представить более подходящей одежды на лето - как юбка в складку! Струящаяся и легкая ткань этой юбки идеально подходит для нанесения красочного рисунка и, тем самым, сделать летний день ещё более ярким. Наша юбка в складку прекрасно сидит на талии, а длинна выше колена. Приятная на ощупь, удобная в носке и не требующая особого ухода - юбка станет любимой вещью в Вашем гардеробе.</p>
      `
    }
  },
  {
    id: `printing`,
    title: `Способ печати`,
    content: {
      printingInfo: `
        <p>
          Способ печати - сублимация. Принт становится частью ткани и не чувствуется на ощупь. Картинка получается яркой и сочной. Изображение не стирается, не выцветает и не трескается.
        </p>
        <p>Можно стирать в машинке. Гладить, желательно, на изнанку.</p>
      `
    }
  },
  {
    id: `size`,
    title: `Размерная сетка`,
    content: {
      table: size[`pleated_skirt`],
      sizeInfo: `pleated_skirt`
    }
  },
  {
    id: `price`,
    title: `Цены`
  },
  {
    id: `delivery`,
    title: `Доставка и оплата`
  },
  {
    id: `reviews`,
    title: `Отзывы`
  }
];
